var _path, _path2, _path3, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGasMulti(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 24,
    viewBox: "0 0 19 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.1517 15.9239C16.1517 20.3773 12.5295 24 8.07703 24H8.04422C3.60537 23.9827 0 20.3665 0 15.9239C0 13.4825 1.2432 11.5844 2.62844 9.69526L2.64203 9.67698L8.0761 2.75032L13.5233 9.69526C14.9085 11.5844 16.1517 13.4825 16.1517 15.9239Z",
    fill: "#1592D2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.1518 15.9239C16.1518 20.3773 12.5296 24 8.07711 24H8.07617V2.75032L13.5234 9.69526C14.9086 11.5844 16.1518 13.4825 16.1518 15.9239Z",
    fill: "#00609B"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M18.8879 7.92187C18.8879 10.6009 16.7086 12.7808 14.03 12.7808H14.0295L13.9714 12.7803C11.3191 12.7493 9.17065 10.5817 9.17065 7.92187C9.17065 6.45319 9.8996 5.3375 10.7115 4.23025L10.7256 4.21197L14.0295 0L17.3471 4.23025C18.159 5.3375 18.8879 6.45319 18.8879 7.92187Z",
    fill: "#0F70AC"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M18.888 7.92187C18.888 10.6009 16.7086 12.7808 14.03 12.7808H14.0295V0L17.3471 4.23025C18.159 5.3375 18.888 6.45319 18.888 7.92187Z",
    fill: "#1592D2"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGasMulti);
export default __webpack_public_path__ + "static/media/GasMulti.355e5d815d9c1b37025085b02c3b30f8.svg";
export { ForwardRef as ReactComponent };